import { cx } from '@linaria/core';
import { useRef, useState, useEffect } from 'react';
import { useToggleState, useChangeEffect } from '@utils/react';
import { flipWrapper, cardSideWrapper, questionSide, answerSide, wrapper, modifiers } from './_card.style.js';
import { CardSide } from './atom.card-side.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useMarkCardAsSeenMutation } from '../../state/mutation.mark-card-as-seen.js';
import { useUpdateLocationMutation } from '../../state/mutation.update-location.js';

function Card(props) {
  const wrapperRef = useRef(null);
  const imageRef = useRef(null);
  const markAsSeen = useMarkCardAsSeenMutation(props.entryKey);
  const updateLocation = useUpdateLocationMutation(props.entryKey);
  const [hasFocus, setHasFocus] = useState(false);
  const [isFlipped, setFlipped] = useToggleState(false);
  const handleFlip = evt => {
    evt.stopPropagation();
    setFlipped.toggle();
    setTimeout(() => {
      markAsSeen(props.index);
    });
  };
  useChangeEffect(() => {
    setFlipped.disable();
  }, [props.entryKey]);

  // allow user to scroll up/down using arrows on his keyboard
  useEffect(() => {
    const onKeyDown = evt => {
      switch (evt.key) {
        case "ArrowDown":
          {
            if (!hasFocus) {
              return;
            }
            wrapperRef.current?.querySelector(`.${cardSideWrapper}.active`)?.scrollBy({
              top: 100,
              behavior: "smooth"
            });
            evt.preventDefault();
            break;
          }
        case "ArrowUp":
          {
            if (!hasFocus) {
              return;
            }
            wrapperRef.current?.querySelector(`.${cardSideWrapper}.active`)?.scrollBy({
              top: -100,
              behavior: "smooth"
            });
            evt.preventDefault();
            break;
          }
        case "Tab":
          setTimeout(() => {
            if (document.activeElement === wrapperRef.current || document.activeElement?.contains(wrapperRef.current)) {
              props.pagination.goTo(props.index);
              updateLocation(props.index);
            }
          });
          break;
      }
    };
    window.addEventListener("keydown", onKeyDown, {
      capture: true
    });
    return () => {
      window.removeEventListener("keydown", onKeyDown, {
        capture: true
      });
    };
  }, [hasFocus, props.index, props.pagination, updateLocation]);
  return /*#__PURE__*/jsx("section", {
    className: cx(wrapper, isFlipped && modifiers.flipped.className),
    "data-disable-polly": !props.visible,
    children: /*#__PURE__*/jsxs("div", {
      ref: wrapperRef,
      className: flipWrapper
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      ,
      tabIndex: 0,
      "aria-roledescription": "Vendekort",
      onKeyDown: event => {
        if (event.key === "Enter" || event.key === " ") {
          handleFlip(event);
          event.preventDefault();
        }
      },
      onFocus: () => {
        setHasFocus(true);
      },
      onBlur: () => setHasFocus(false),
      onClick: evt => {
        const selection = window.getSelection();
        const range = selection?.rangeCount ? selection.getRangeAt(0) : undefined;
        const hasSelectionInCard = range?.commonAncestorContainer ? !!range.toString() && (wrapperRef.current?.contains(range.commonAncestorContainer) || wrapperRef.current === range.commonAncestorContainer) : false;
        if (evt.button === 0 && !props.visible && !hasSelectionInCard) {
          props.pagination.goTo(props.index);
          updateLocation(props.index);
        }
      },
      children: [/*#__PURE__*/jsx("div", {
        className: cx(cardSideWrapper, questionSide, !isFlipped && "active"),
        "data-visible": props.visible,
        tabIndex: -1,
        children: /*#__PURE__*/jsx(CardSide, {
          tooltipTargetRef: imageRef,
          content: props.card.question,
          isActive: !isFlipped && props.visible,
          isVisible: !isFlipped,
          onFlipButtonClicked: handleFlip,
          fallbackLabel: props.globalLabels.question,
          cardHasFocus: hasFocus
        })
      }), /*#__PURE__*/jsx("div", {
        className: cx(cardSideWrapper, answerSide, isFlipped && "active"),
        "data-visible": props.visible,
        tabIndex: -1,
        children: /*#__PURE__*/jsx(CardSide, {
          tooltipTargetRef: imageRef,
          content: props.card.answer,
          isActive: isFlipped && props.visible,
          isVisible: isFlipped,
          onFlipButtonClicked: handleFlip,
          fallbackLabel: props.globalLabels.answer,
          cardHasFocus: hasFocus
        })
      })]
    })
  });
}

export { Card };
//# sourceMappingURL=_card.js.map
